module.exports = __webpack_public_path__ + "e60d254ad392e2da8e435289cd2008f2.png";